export const api = {
  userTypes: '/user/types',
  countries: '/countries-list',
  countriesAll: '/countries-list-all',
  categories: '/product-categories-list',
  fileUploadSetting: '/file-upload-setting',
  fileUploadProcess: '/file-upload-process',
  mastersKey: '/master/keys',
  languages: '/languages-list',
  dynamicContent: '/country-dynamic-content/types',
  countryRelation: '/country/relation',
  states: '/states/',
  cities: '/cities/',
  searchMember: '/member-list',
  commissionWeek: '/cw-schedules-list',
  userDetails: '/user',
  workflowUpdate: '/workflow-tracking-step-update',
  giroType: '/setting/giro-types',
  inventoryProcurementAccessToken: '/get-oauth-token',
  stockLocations: '/stock-locations',
  getLocationTypes: '/locations-types-list',
  requestMobileNumberValidation: '/mobile-code',
  verifyMobileNumber: '/mobile-verify',
  requestEmailValidation: '/email-code',
  verifyEmail: '/email-verify',
  userFieldVerification: '/user-on-demand-verification',
  userFieldCrossSponsoringCheck: '/member-cross-sponsoring-check',
  userAuthorizedReports: '/user/authorized-reports',
  settings: '/settings',
  updateSettings: '/update-settings',
  locationsAddresses: '/locations-addresses-list',
  config: '/hierarchical-config',
  listItems: '/list-items/lookup/receipt',
  productDocumentTemplateDownload: '/product-template/download',
  productDocumentTemplateUpload: '/product-template/upload',
  roundingCalculation: '/rounding-calculation',
  paymentsMethods: '/payments',
}
